"use client";

import { ButtonLink, TVacancyCtaSection } from "@shared/cms";
import { useIsTablet } from "@ubud-ui/react-ui-kit";
import Image from "next/image";

export function VacancyCta({ title, description, button, image, backgroundDesktop, backgroundMobile }: TVacancyCtaSection) {
  const isTablet = useIsTablet();

  return (
    <section
      className="cta-section bg-primary bg-cover"
      style={{ backgroundImage: !isTablet ? "url(" + backgroundDesktop.url + ")" : "url(" + backgroundMobile.url + ")" }}
    >
      <div className="container">
        <div className="flex flex-col md:flex-row">
          <div className="pt-14 pb-10 sm:pt-32 sm:pb-16 md:pb-32 max-w-[456px]">
            <div className="text-4xl sm:text-5xl font-bold text-white">{title}</div>
            {description && <div className="text-white mt-4 text-base sm:text-lg">{description}</div>}
            {button && (
              <div className="mt-10">
                <ButtonLink {...button} size="sm" />
              </div>
            )}
          </div>
          <div className="relative flex-1 overflow-hidden">
            <Image
              src={image.url}
              alt={image.alternativeText || image.name || ""}
              className="w-[110%] md:w-[120%] max-h-[500px] xl:w-auto xl:h-full md:absolute bottom-0 -right-12 xl:-right-16 max-w-none object-contain"
              width={image.width || 717}
              height={image.height || 508}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
